import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to UI/UX Design",
    points: [
      "What is UI vs UX design",
      "Design thinking process overview",
      "Role of a UI/UX designer in industry",
      "Principles of user-centered design",
    ],
  },
  {
    title: "User Research & Analysis",
    points: [
      "Understanding user personas",
      "Conducting user interviews and surveys",
      "Competitor analysis techniques",
      "Identifying user pain points",
    ],
  },
  {
    title: "Wireframing & Information Architecture",
    points: [
      "Creating low-fidelity wireframes",
      "Structuring user flows and journeys",
      "Information architecture basics",
      "Navigation and layout planning",
    ],
  },
  {
    title: "UI Design Fundamentals",
    points: [
      "Color theory and typography basics",
      "Spacing, alignment, and visual hierarchy",
      "Design consistency and branding",
      "Creating modern UI layouts",
    ],
  },
  {
    title: "Tools for UI/UX Design",
    points: [
      "Figma for UI design and prototyping",
      "Adobe XD basics",
      "Wireframing tools and plugins",
      "Collaboration using design tools",
    ],
  },
  {
    title: "Prototyping & Interaction Design",
    points: [
      "Creating interactive prototypes",
      "Micro-interactions and animations",
      "User flow testing",
      "Clickable prototype development",
    ],
  },
  {
    title: "Usability Testing",
    points: [
      "Types of usability testing methods",
      "Gathering and analyzing feedback",
      "Improving designs based on testing",
      "A/B testing basics",
    ],
  },
  {
    title: "Design Systems & Components",
    points: [
      "Building reusable UI components",
      "Design system structure",
      "Style guides and documentation",
      "Consistency in large-scale applications",
    ],
  },
  {
    title: "Portfolio & Real-Time Projects",
    points: [
      "Creating UI/UX case studies",
      "Building a professional design portfolio",
      "Real-world app redesign projects",
      "Interview preparation for UI/UX roles",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive UI/UX syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
